import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { addToDataBase } from '../../redux/actions/dataBase';
import Comment from './Comment';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  message: {
    borderRadius: '20px',
    width: '150px',
    maxWidth: 'fit-content',
    padding: '8px 20px',
    wordBreak: 'break-word',
    fontSize: '15px',
    color: '#000',
    userSelect: 'all',
  },
  bgBlueGreen: {
    backgroundColor: '#44bec7',
    color: '#fff',
  },
  bgGray: {
    backgroundColor: '#f2f3f5',
  },
  commentsContainer: {
    // overflowY: 'scroll',
    paddingBottom: '3rem',
    height: '90vh',
  },
  comments: {
    overflowY: 'scroll',
    paddingBottom: '5rem',
    height: '90vh',
    marginBottom: '7rem',
    scrollbarWidth: 'none',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '12rem',
    },
  },
  form: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    margin: '0 auto',
    backgroundColor: '#f2f3f5',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '243px',
    padding: '5px 10px',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  name: {
    border: 0,
    borderBottom: '1px solid #bfbfbf',
    outline: 'none',
    width: '232px',
    padding: '10px',
    backgroundColor: '#f2f3f5',
    fontFamily: 'HarmoniaSansStd',
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      width: '87%',
    },
  },
  inputContainer: {
    border: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: 10,
  },
  content: {
    border: 0,
    width: '200px',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      width: '80%',
    },
  },
  submitBtn: { border: 0, backgroundColor: 'transparent', cursor: 'pointer' },
}));

function CreateComment({ comments, proposalId, addToDataBase }) {
  const [name, setName] = React.useState('');
  const [content, setContent] = React.useState('');
  const commentRef = React.useRef();
  const classes = useStyles();
  const { t } = useTranslation();

  const resetFields = () => {
    setName('');
    setContent('');
    commentRef.current.textContent = '';
  };

  const handleChange = event => {
    const { name, value, textContent } = event.target;

    if (name === 'name') {
      setName(value);
    }
    setContent(textContent);
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (!content) return;
    const id = Date.parse(new Date()).toString();
    const comment = {
      commentId: id,
      name: !name ? 'Anonymous' : name,
      content,
      proposalId,
      isNew: true,
      createdAt: new Date(),
    };

    addToDataBase('comments', id, { ...comment })
      .then(() => {
        resetFields();
      })
      .catch(error => console.log(error));
  };

  React.useEffect(() => {
    if (commentRef.current) commentRef.current.focus();
  }, [commentRef]);

  return (
    <div className={classes.commentsContainer}>
      <div className={classes.comments} onClick={() => commentRef.current.focus()}>
        {comments.length === 0 ? (
          <p>{t('No comments')}</p>
        ) : (
          comments.map(comment => {
            return <Comment key={comment.commentId} comment={comment} />;
          })
        )}
      </div>

      {/* <form onSubmit={handleSubmit} className={classes.form}>
        <input
          className={classes.name}
          type="text"
          placeholder="Anonymous"
          name="name"
          value={name}
          onChange={handleChange}
        />
        <div className={classes.inputContainer}>
          <div
            role="textbox"
            onBlur={e => handleChange(e)}
            value={content}
            className={classes.content}
            contentEditable
            ref={commentRef}
            placeholder={t('Content')}
            suppressContentEditableWarning={true}
          />

          <button type="submit" className={classes.submitBtn}>
            <SendIcon style={{ color: '#3f51b5' }} />
          </button>
        </div>
      </form> */}
    </div>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    addToDataBase: (coll, doc, data) => dispatch(addToDataBase(coll, doc, data)),
  };
};

export default compose(connect(null, mapDispatchToProps))(CreateComment);
